import React from 'react';
import PropTypes from 'prop-types';
import './TrainingLink.scss';
import Tooltip from '@mui/material/Tooltip';
const TrainingLink = ({className, link}) => {
    const [open, setOpen] = React.useState(false);
  const resolvedClassName = link ? className : 'disabled';
  const attr = link ? {href: link} : {};
  const hyperlink = (
      <a {...attr}
         className={`TrainingLink ${resolvedClassName}`}
         data-testid="TrainingLink"
         target="_blank"
         rel="noopener noreferrer"
         onMouseEnter={() => setOpen(true)}
         onMouseLeave={() => setOpen(false)}
      >
          Training
      </a>
  );

  if (link) return hyperlink;
  return (
      <Tooltip
          open={open}
          placement="left"
          arrow
          title="Training is unavailable at the moment. Please try again later.">
          {hyperlink}
      </Tooltip>
  );
};

TrainingLink.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string,
};

TrainingLink.defaultProps = {
  className: '',
  link: '',
};

export default TrainingLink;